// banner 配置
export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1D1B2KXzqK1RjSZFvXXcB7VXa-1920-480.jpg',
  mcover: 'https://gw.alicdn.com/tfs/TB1PbycM7voK1RjSZFNXXcxMVXa-750-320.png',
  title: {
    url: 'https://img.alicdn.com/tfs/TB1swdRKmrqK1RjSZK9XXXyypXa-644-58.png',
    text: '数据让健康触手可及',
  },
};
